import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchCertificado} from '../../../../store/empresa';
import EmpresaCertificadoCreatePage from './_create';
import EmpresaCertificadoDetailPage from './_detail';
import EmpresaCertificadoEditPage from './_edit';

export default function EmpresaCertificadoPage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchCertificado({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/certificados/:id/edit" component={EmpresaCertificadoEditPage} />
        <Route path="/*/empresas/:empresaId/certificados/create" component={EmpresaCertificadoCreatePage} />
        <Route path="/*/empresas/:empresaId/certificados/:id" component={EmpresaCertificadoDetailPage} />
      </Switch>);
}
